export default "__VITE_ASSET__u50yWEyt__"